import React from 'react';

export const TermsContent = () => (
    <div style={{ marginBottom: '20px', color: '#333', lineHeight: '1.6', fontSize: '14px' }}>
        <p style={{ textAlign: 'center', fontWeight: 'bold' }}>(ZENTHOR)</p>
        <p style={{ textAlign: 'center', fontSize: '12px', color: '#666' }}>Última actualización: 2025</p>

        <h3 style={{ color: '#1d295f', marginTop: '20px' }}>Objeto</h3>
        <p>Zenthor es una aplicación destinada a promover el bienestar emocional mediante herramientas, contenido educativo y funcionalidades asistidas por inteligencia artificial. Zenthor no es un servicio clínico ni reemplaza la orientación o tratamiento psicológico profesional.</p>

        <h3 style={{ color: '#1d295f', marginTop: '20px' }}>Aceptación</h3>
        <p>Al utilizar la aplicación usted acepta íntegramente los presentes Términos y Condiciones. Si no está de acuerdo, deberá abstenerse de utilizar el servicio.</p>

        <h3 style={{ color: '#1d295f', marginTop: '20px' }}>Elegibilidad</h3>
        <p>El uso de la aplicación está permitido únicamente a personas mayores de 18 años. Al utilizar la plataforma, usted declara ser mayor de edad.</p>

        <h3 style={{ color: '#1d295f', marginTop: '20px' }}>Uso permitido</h3>
        <p>El usuario se compromete a utilizar la aplicación de forma lícita, sin infringir derechos de terceros, sin realizar actividades fraudulentas, ofensivas o contrarias a la ley.</p>

        <h3 style={{ color: '#1d295f', marginTop: '20px' }}>Limitación de responsabilidad</h3>
        <p>Las herramientas ofrecidas por Zenthor tienen finalidad informativa y de bienestar general. Zenthor no garantiza resultados clínicos, diagnósticos ni terapéuticos. El usuario es responsable del uso que realice de la información. Zenthor no será responsable de daños directos o indirectos derivados del uso indebido del servicio.</p>
        <p>Ante situaciones de riesgo, crisis emocional, ideación suicida o emergencia, usted debe contactar inmediatamente a servicios médicos o autoridades competentes en su país.</p>

        <h3 style={{ color: '#1d295f', marginTop: '20px' }}>Contenido generado por el usuario</h3>
        <p>El usuario puede generar mensajes y contenido dentro de la aplicación. Dicho contenido podrá ser utilizado de forma anonimizada con fines de mejora del servicio, estadística, investigación y desarrollo tecnológico.</p>

        <h3 style={{ color: '#1d295f', marginTop: '20px' }}>Propiedad intelectual</h3>
        <p>Todos los contenidos, textos, imágenes, audios, diseños, software y elementos disponibles en la aplicación son propiedad de Zenthor o cuentan con licencia. Queda prohibida la reproducción, distribución o modificación sin autorización.</p>

        <h3 style={{ color: '#1d295f', marginTop: '20px' }}>Modificaciones</h3>
        <p>Zenthor podrá modificar estos Términos y Condiciones cuando sea necesario. Las modificaciones serán publicadas en la aplicación. El uso continuado implica aceptación de las mismas.</p>

        <h3 style={{ color: '#1d295f', marginTop: '20px' }}>Cancelación de cuenta</h3>
        <p>El usuario podrá solicitar la eliminación de su cuenta enviando un correo a <a href="mailto:zenthorapp@gmail.com" style={{ color: '#4b8fa2' }}>zenthorapp@gmail.com</a> o a través de los mecanismos disponibles dentro de la aplicación.</p>

        <h3 style={{ color: '#1d295f', marginTop: '20px' }}>Legislación aplicable</h3>
        <p>Estos Términos y Condiciones se rigen por la legislación española y por la normativa de la Unión Europea.</p>

        <hr style={{ margin: '30px 0', border: 'none', borderTop: '2px solid #e0e0e0' }} />

        <h2 style={{ color: '#1d295f', textAlign: 'center', marginTop: '30px' }}>POLÍTICA DE PRIVACIDAD Y PROTECCIÓN DE DATOS</h2>
        <p style={{ textAlign: 'center', fontWeight: 'bold' }}>(UE – GDPR 2016/679)</p>
        <p style={{ textAlign: 'center', fontSize: '12px', color: '#666' }}>Última actualización: 2025</p>

        <h3 style={{ color: '#1d295f', marginTop: '20px' }}>Responsable del Tratamiento</h3>
        <p><strong>Responsable:</strong> Zenthor</p>
        <p><strong>Contacto:</strong> <a href="mailto:zenthorapp@gmail.com" style={{ color: '#4b8fa2' }}>zenthorapp@gmail.com</a></p>

        <h3 style={{ color: '#1d295f', marginTop: '20px' }}>Finalidad del Tratamiento</h3>
        <p>Los datos personales se tratarán exclusivamente para:</p>
        <ul style={{ paddingLeft: '20px' }}>
            <li>Permitir el funcionamiento de la plataforma</li>
            <li>Gestionar la cuenta del usuario</li>
            <li>Personalizar la experiencia</li>
            <li>Mejorar el servicio</li>
            <li>Seguridad y prevención de abusos</li>
            <li>Análisis estadístico</li>
            <li>Investigación y desarrollo (de forma anonimizada)</li>
        </ul>

        <h3 style={{ color: '#1d295f', marginTop: '20px' }}>Datos tratados</h3>
        <p>Podrán tratarse los siguientes datos:</p>
        <ul style={{ paddingLeft: '20px' }}>
            <li>Correo electrónico</li>
            <li>Identificadores técnicos</li>
            <li>Metadatos de conexión</li>
            <li>Estadísticas de uso</li>
            <li>Mensajes enviados al asistente de IA</li>
            <li>Información proporcionada dentro de la app</li>
        </ul>
        <p>Los mensajes pueden contener información emocional; se tratarán de manera segura y se utilizarán de forma anonimizada cuando sea posible.</p>

        <h3 style={{ color: '#1d295f', marginTop: '20px' }}>Base legal según GDPR</h3>
        <p>El tratamiento se basa en:</p>
        <ul style={{ paddingLeft: '20px' }}>
            <li>Consentimiento del usuario</li>
            <li>Ejecución de un contrato/servicio digital</li>
            <li>Interés legítimo proporcional</li>
        </ul>

        <h3 style={{ color: '#1d295f', marginTop: '20px' }}>Destinatarios</h3>
        <p>Podemos utilizar proveedores tecnológicos ubicados dentro y fuera de la Unión Europea, garantizando un nivel adecuado de protección conforme al GDPR mediante cláusulas contractuales tipo u otros mecanismos equivalentes.</p>

        <h3 style={{ color: '#1d295f', marginTop: '20px' }}>Conservación</h3>
        <p>Los datos se conservarán mientras exista relación con el usuario. Posteriormente podrán ser conservados de forma anonimizada con fines estadísticos, de investigación o mejora del servicio.</p>

        <h3 style={{ color: '#1d295f', marginTop: '20px' }}>Derechos del usuario</h3>
        <p>El usuario tiene derecho a:</p>
        <ul style={{ paddingLeft: '20px' }}>
            <li>Acceder a sus datos</li>
            <li>Rectificarlos</li>
            <li>Suprimirlos</li>
            <li>Solicitar limitación</li>
            <li>Portabilidad</li>
            <li>Oponerse</li>
            <li>Retirar el consentimiento en cualquier momento</li>
        </ul>
        <p>Para ejercer estos derechos puede escribir a: <a href="mailto:zenthorapp@gmail.com" style={{ color: '#4b8fa2' }}>zenthorapp@gmail.com</a></p>

        <h3 style={{ color: '#1d295f', marginTop: '20px' }}>Seguridad</h3>
        <p>Zenthor adopta medidas técnicas y organizativas adecuadas para proteger los datos personales y evitar accesos no autorizados, pérdida o alteración.</p>

        <h3 style={{ color: '#1d295f', marginTop: '20px' }}>Transferencias Internacionales</h3>
        <p>Si se realizan transferencias de datos fuera del Espacio Económico Europeo, se garantizarán los niveles adecuados de protección exigidos por la legislación europea.</p>

        <h3 style={{ color: '#1d295f', marginTop: '20px' }}>Menores</h3>
        <p>Esta aplicación no está dirigida a menores de edad. Si se detecta que se ha recopilado información de menores, será eliminada de forma segura.</p>

        <h3 style={{ color: '#1d295f', marginTop: '20px' }}>Política de cookies</h3>
        <p>Si se utilizan cookies o tecnologías similares, el usuario será informado a través del correspondiente aviso, panel de gestión o política específica.</p>

        <h3 style={{ color: '#1d295f', marginTop: '20px' }}>Cambios en la Política</h3>
        <p>Zenthor podrá modificar esta Política de Privacidad para adaptarla a nuevas exigencias legales o funcionales. La versión vigente se encontrará siempre publicada en la aplicación.</p>
    </div>
);
